import { LEGEND, ROLE_COLORS, RUNNER_COLOR } from "@/lib/roles";

export const Legend = () => (
  <div className="flex flex-wrap gap-x-4 gap-y-2" data-testid="role-legend">
    {LEGEND.map((l) => (
      <span key={l.key} className="legend-item">
        <span className="legend-dot" style={{ background: ROLE_COLORS[l.key] }} />
        {l.label}
      </span>
    ))}
    <span className="legend-item">
      <span className="legend-dot legend-ring" style={{ borderColor: RUNNER_COLOR }} />
      Runner
    </span>
  </div>
);
